import { App } from 'vue'
import VueClipboard from 'vue3-clipboard'

export default {
  install(app: App<Element>) {
    app.use(VueClipboard, {
      autoSetContainer: true,
      appendToBody: true,
    })
  }
}
